export const environment = {
  production: false,
  local: false,
  api: 'https://api.dev.betterchains.net',
  cdn: 'https://cdn.dev.betterchains.net',
  sentryEnabled: true,
  sentryDsn: "https://febb4f45e90befdfa68cbc4eb8d80dc4@o4508915371999232.ingest.us.sentry.io/4510062775042048",
  sentryEnv: 'dev'
};
